import { JsonObject, JsonProperty } from 'json2typescript';
import { DateConverter } from '@shared/entities/converters/date-converter';

@JsonObject('SFAccount')
export class SFAccount {
  @JsonProperty('id', String)
  public id?: string = undefined;

  @JsonProperty('isDeleted', Boolean)
  public isDeleted?: boolean = undefined;

  @JsonProperty('masterRecordId', String)
  public masterRecordId?: string = undefined;

  @JsonProperty('name', String)
  public name?: string = undefined;

  @JsonProperty('type', String)
  public type?: string = undefined;

  @JsonProperty('recordTypeId', String)
  public recordTypeId?: string = undefined;

  @JsonProperty('parentId', String)
  public parentId?: string = undefined;

  @JsonProperty('billingCity', String)
  public billingCity?: string = undefined;

  @JsonProperty('billingStreet', String)
  public billingStreet?: string = undefined;

  @JsonProperty('billingState', String)
  public billingState?: string = undefined;

  @JsonProperty('billingPostalCode', String)
  public billingPostalCode?: string = undefined;

  @JsonProperty('billingCountry', String)
  public billingCountry?: string = undefined;

  @JsonProperty('shippingCity', String)
  public shippingCity?: string = undefined;

  @JsonProperty('shippingStreet', String)
  public shippingStreet?: string = undefined;

  @JsonProperty('shippingState', String)
  public shippingState?: string = undefined;

  @JsonProperty('shippingPostalCode', String)
  public shippingPostalCode?: string = undefined;

  @JsonProperty('shippingCountry', String)
  public shippingCountry?: string = undefined;

  @JsonProperty('phone', String)
  public phone?: string = undefined;

  @JsonProperty('website', String)
  public website?: string = undefined;

  @JsonProperty('industry', String)
  public industry?: string = undefined;

  @JsonProperty('numberOfEmployees', String)
  public numberOfEmployees?: string = undefined;

  @JsonProperty('description', String)
  public description?: string = undefined;

  @JsonProperty('lastModifiedDate', DateConverter)
  public lastModifiedDate?: Date = undefined;

  @JsonProperty('lastModifiedById', String)
  public lastModifiedById?: string = undefined;

  @JsonProperty('accountSource', String)
  public accountSource?: string = undefined;

  @JsonProperty('sicDesc', String)
  public sicDesc?: string = undefined;

  @JsonProperty('noMailing__c', String)
  public noMailing?: string = undefined;

  @JsonProperty('partner_c', String)
  public partner?: string = undefined;

  @JsonProperty('privacy_c', String)
  public privacy?: string = undefined;

  @JsonProperty('payTerm_c', String)
  public payTerm?: string = undefined;

  @JsonProperty('agent__c', String)
  public agent?: string = undefined;

  @JsonProperty('customer__c', String)
  public customer?: string = undefined;
}
